import ProjectEditor from "../../components/admin/ProjectEditor.jsx";

export default function ProjectsPage() {
  return (
    <section style={{ display: "grid", gap: "1.5rem" }}>
      <header>
        <span className="mono-tag">// 03 — Repositorio</span>
        <h1
          style={{
            fontSize: "var(--step-3)",
            fontWeight: 300,
            letterSpacing: "-0.02em",
            marginTop: "0.5rem",
          }}
        >
          Repositorio de <strong>proyectos</strong>
          <span style={{ color: "var(--color-accent)" }}>.</span>
        </h1>
        <p
          style={{
            color: "var(--color-ink-soft)",
            marginTop: "0.5rem",
            maxWidth: "65ch",
          }}
        >
          Crea un proyecto por cada máquina/equipo. Cada uno admite galería de
          imágenes y documentos (fichas, manuales, planos).
        </p>
      </header>

      <ProjectEditor />
    </section>
  );
}
